import * as React from "react";
import { MapPin, Clock, Car } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Link } from "@/components/common/Link";
const hoursData = [{
  days: "Monday – Friday",
  times: "9:00 AM – 5:00 PM"
}, {
  days: "Saturday – Sunday",
  times: "Closed"
}];
export default function TheUrbanLocation() {
  return <section data-section-id="226210" id="our-sydney-office" className="bg-background text-foreground py-24 sm:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/5 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          

          {}
          <div className="flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="h-px w-8 bg-primary/50" />
              <span className="font-default text-xs font-semibold tracking-widest uppercase text-primary">Visit Our Office</span>
            </div>
            
            <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-8">
              Our Sydney <br className="hidden sm:block" />
              <span className="text-secondary italic">Headquarters</span>
            </h2>

            <div className="space-y-10">
              {}
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/10 p-3 rounded-full text-primary shrink-0">
                  <MapPin className="size-5" />
                </div>
                <div>
                  <h3 className="font-default text-xl font-semibold mb-2">Address</h3>
                  <p className="font-default text-muted-foreground leading-relaxed">Level 26/44 Market St, Sydney NSW 2000</p>
                </div>
              </div>

              {}
              <div className="flex items-start gap-4">
                <div className="mt-1 bg-primary/10 p-3 rounded-full text-primary shrink-0">
                  <Clock className="size-5" />
                </div>
                <div className="w-full">
                  <h3 className="font-default text-xl font-semibold mb-4">Opening Hours</h3>
                  <Table className="w-full">
                    <TableBody>
                      {hoursData.map((row, i) => <TableRow key={i} data-index={i} className="border-b border-border hover:bg-transparent">
                          <TableCell className="font-default text-muted-foreground py-4 pl-0 border-none">
                            {row.days}
                          </TableCell>
                          <TableCell className="text-right font-default text-foreground py-4 pr-0 font-medium border-none">
                            {row.times}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>

              {}
              <div className="pt-6 border-t border-border">
                <p className="font-default text-sm text-muted-foreground mb-6">Located in the heart of Sydney's financial district. We recommend booking a consultation with our brokers for a personalised strategy.</p>
                <Link to="#">
                  
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}